import React from "react";

const LoadingComp = () => <i className="fa fa-spinner fa-spin fa-2x"> </i>;

export default LoadingComp;
